import React, { Component } from "react";
import { Link } from "react-router-dom";
import { InputItem, List, WhiteSpace, Button, Toast } from "antd-mobile-v2";
import "./index.less";
import tool from "../../api/tool";
export default class AsscateD extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }
  componentDidMount() {
    // 获取联名人数据
    console.log(this.props, "不一样");
    let asscateData = tool.get("asscateData");
    this.setState({ data: asscateData });
  }
  // 添加联名人
  onAddAsscate = () => {
    tool.set("editData", {});
    this.props.history.push("/addasscate");
  };
  render() {
    const { data } = this.state;
    const liantype =
      this.props.location.state && this.props.location.state.lianType
        ? this.props.location.state.lianType
        : "add";
    return (
      <div className="asscate-wrapper">
        <div className="ascate-cont">
          {data && data.length > 0 ? (
            <div className="asscate-list">
              {data.map((item, index) => {
                return (
                  <div className="asscate-item" key={index}>
                    <div className="item-name">
                      <span style={{ color: "#151515", fontSize: "0.16rem" }}>
                        {item.jointPersonName}
                      </span>
                      &nbsp;{" "}
                      <span style={{ color: "#989898" }}>
                        {item.jointPersonId}
                      </span>
                    </div>
                    <div className="item-address">
                      {`${item.personProvinceName}-${item.personCityName}-${item.personRegionName} ${item.personAddress}`}
                    </div>
                    {/* <div
                      className="item-edit"
                      onClick={() => {
                        tool.set("editData", {
                          data: item,
                          key: index,
                        });
                        this.props.history.push("/addasscate");
                      }}
                    >
                      编辑
                    </div> */}
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="empty-data">暂无联名人</div>
          )}
        </div>
        {
          liantype == "add" ? <div className="asscate-foter">
            <Button type="primary" onClick={this.onAddAsscate}>
              添加联名人
            </Button>
          </div> : null
        }

      </div>
    );
  }
}
